import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import {
  getCouponT,
  getStoredCouponLang,
  normalizeCouponLang,
  storeCouponLang,
} from '../i18n/couponLocale';

const CouponLocaleContext = createContext(null);

export function CouponLocaleProvider({ children }) {
  const [lang, setLangState] = useState(() => getStoredCouponLang());

  const setLang = useCallback((next) => {
    const v = normalizeCouponLang(next);
    storeCouponLang(v);
    setLangState(v);
  }, []);

  const t = useCallback((key, vars) => getCouponT(lang, key, vars), [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return (
    <CouponLocaleContext.Provider value={value}>
      {children}
    </CouponLocaleContext.Provider>
  );
}

export function useCouponLocale() {
  const ctx = useContext(CouponLocaleContext);
  if (!ctx) {
    throw new Error('useCouponLocale must be used within CouponLocaleProvider');
  }
  return ctx;
}

export function CouponLangSwitch({ px = (n) => n, style = {} }) {
  const { lang, setLang, t } = useCouponLocale();
  const btn = (target, label) => ({
    padding: `${px(8)}px ${px(16)}px`,
    fontSize: `${px(28)}px`,
    fontWeight: lang === target ? 900 : 600,
    border: `${px(2)}px solid #111`,
    borderRadius: `${px(10)}px`,
    background: lang === target ? '#111' : '#fff',
    color: lang === target ? '#fff' : '#111',
    cursor: 'pointer',
  });
  return (
    <div style={{ display: 'flex', gap: `${px(8)}px`, justifyContent: 'flex-end', marginBottom: `${px(12)}px`, ...style }}>
      <button type="button" style={btn('zh-TW', t('langZh'))} onClick={() => setLang('zh-TW')}>
        {t('langZh')}
      </button>
      <button type="button" style={btn('en', t('langEn'))} onClick={() => setLang('en')}>
        {t('langEn')}
      </button>
    </div>
  );
}
